import { featureVisuals } from '@/content/site.js';

export default function Features({ t }) {
  return (
    <section id="features" className="features">
      <div className="container">
        <div className="reveal sec-head">
          <div className="eyebrow">{t.eyebrow}</div>
          <h2>{t.title}</h2>
          <p>{t.lead}</p>
        </div>

        <div className="features-grid">
          {t.items.map((f, idx) => {
            const art = featureVisuals[idx];
            return (
              <div className="reveal feature-card" key={f.title}>
                <div
                  className="feature-icon"
                  style={{ background: `linear-gradient(135deg, ${art.c1}, ${art.c2})`, boxShadow: `0 10px 28px ${art.glow}, inset 0 1px 0 rgba(255,255,255,.4)` }}
                >
                  <span>{art.icon}</span>
                </div>
                <div className="feature-title">{f.title}</div>
                <div className="feature-body">{f.body}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
